// extracted by mini-css-extract-plugin
module.exports = {"no_focus":"styles__no_focus___n3xyo","custom_styles":"styles__custom_styles___1RLQF"};